import React from 'react';
import { useNavigate, useLocation, useParams } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import * as JSURL from 'jsurl';
import Utils from './Utils';
import moment from 'moment';

export const withRouter = (Component) => {
  const Wrapper = (props) => {
    let navigate = useNavigate();
    let location = useLocation();
    let params = useParams();
    let [searchParams, setSearchParams] = useSearchParams();

    return (
      <Component
        navigate={navigate}
        location={location}
        params={params}
        querySearchParams={searchParams}
        setQuerySearchParams={setSearchParams}
        {...props}
      />
    );
  };
  return Wrapper;
};

export function getQueryParams(querySearchParams) {
  if (querySearchParams == undefined) {
    return {};
  }

  let paramsObj = {};

  for (let entry of querySearchParams.entries()) {
    let entryKey = entry[0];
    let entryValue = entry[1];
    paramsObj = Object.assign(paramsObj, { [entryKey]: entryValue });
  }
  return paramsObj;
}

export function getQueryParam(key, type, querySearchParams) {
  if (querySearchParams == undefined) {
    return null;
  }
  let paramValue = querySearchParams.get(key);

  if (paramValue == null || paramValue == undefined) {
    return null;
  }

  let value =
    type && type == 'customDateTimeType'
      ? customDateTimeType.decode(paramValue)
      : decodeURI(paramValue);

  return value;
}

export function setQueryParams(newParamsObj, searchParams, setSearchParams, options = null) {
  let newSearchParams = new URLSearchParams(searchParams);
  Object.keys(newParamsObj).map((paramKey) => {
    let paramValue = newParamsObj[paramKey];
    newSearchParams.set(paramKey, paramValue);
  });

  if (options != null) {
    setSearchParams(newSearchParams, options);
  } else {
    setSearchParams(newSearchParams);
  }
}

export function setQueryParam(newQueryParams, searchParams, setSearchParams, options = null) {
  let newSearchParams = new URLSearchParams(searchParams);

  newQueryParams.forEach((newParam) => {
    let encodedValue =
      newParam.type && newParam.type == 'customDateTimeType'
        ? customDateTimeType.encode(newParam.value)
        : encodeURI(newParam.value);
    if (newParam.value != '') {
      newSearchParams.set(newParam.key, encodedValue);
    }
  });

  if (options != null) {
    setSearchParams(newSearchParams, options);
  } else {
    setSearchParams(newSearchParams);
  }
}

export function useQueryParam(key, searchParamsHook, type) {
  let [searchParams, setSearchParams] = searchParamsHook;
  let paramValue = searchParams.get(key);

  let value = React.useMemo(
    () =>
      type && type == 'customDateTimeType'
        ? customDateTimeType.decode(paramValue)
        : JSURL.parse(paramValue),
    [paramValue]
  );

  let setValue = React.useCallback(
    (newValue, options) => {
      let newSearchParams = new URLSearchParams(searchParams);
      let encodedValue =
        type && type == 'customDateTimeType'
          ? customDateTimeType.encode(newValue)
          : JSURL.stringify(newValue);
      newSearchParams.set(key, encodedValue);
      setSearchParams(newSearchParams, options);
    },
    [key, searchParams, setSearchParams]
  );

  return [value, setValue];
}

export function objectToQueryString(obj) {
  const keys = Object.keys(obj);
  const keyValuePairs = keys.map((key) => {
    return encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]);
  });
  return keyValuePairs.join('&');
}

const customDateTimeType = {
  decode: (encoded) => (encoded ? moment.utc(encoded) : undefined),
  encode: (decoded) =>
    decoded ? Utils.DateFromUtcFe(decoded).milliseconds(0).toISOString() : undefined,
};
